export default {
  companyEmployeesMetadata: {
    titles: {
      createTeam: 'New team',
      changeTeam: 'Edit the team',
      transferTeam: 'Transfer of team members and scores 360',
      deleteTeam: 'Deleting the team',
      inviteEmployee: 'New employee',
      importEmployees: 'Uploading users',
      interconnectSettings: 'Select employees',
    },
    descriptions: {
      transferTeam:
        'Select the members and new teams to which you want to transfer the 360 scores. You can select only one team to transfer.',
      importEmployees:
        'Users are uploading, please do not close the window, if something goes wrong, then at the end we will show you a list of errors.',
      interconnectSettings:
        'Select the group of users for which the interaction diagram will be created. You can create a diagram for the company as a whole, by team, or by specific employees.',
    },
    buttons: {
      addEmployee: 'Add employee',
      inviteEmployee: 'Invite employee',
      downloadTemplate: 'Download the template xls',
      importEmployees: 'Upload xls',
      transferTeam: 'Transfer of team members',
      createTeam: 'Create team',
      changeTeam: 'Edit the team',
      deleteTeam: 'Delete the team',
    },
    formLabels: {
      teamName: 'Team name',
      searchEmployees: 'Name employee',
      authEmailsState: 'Sending emails for authorization',
    },
    tabs: {
      inviteByEmail: 'Invite by e-mail',
      searchInTheList: 'Search in the list',
    },
    tooltips: {
      addEmployee:
        'Adding employees and teams is possible on the businesschain, after which they will be displayed in this company.',
      downloadTemplate: 'Download the template to upload a list of employees to the company',
      importEmployees: 'Upload the completed template to add employees to the company',
      authEmailsState:
        'If the “Disabled” option is selected, then when adding employees to the company, users will not be sent emails with a username and password to log in to the platform.<br/><br/>If the “Enabled” option is selected, then when employees are turned on or when they are added to the company, they will be sent emails with a username and passwords to log in to the platform.',
      transferTeam: 'Transfer of team members and scores',
    },
    // messages
    successMessages: {
      dismissEmployee: 'The employee was successfully dismissed',
      reinstateEmployee: 'The employee was successfully reinstated',
      importEmployees:
        'The added employees will be sent an email to the specified email address with an invitation to the company and a temporary password',
      importEmployeesDialog:
        'All users successfully added to the company, you can close this window.',
      inviteEmployee: 'An invitation has been sent to the employee',
      cancelInvitationEmployee: 'Invitation successfully cancelled',
      disableAuthEmails: 'Sending emails for authorization is disabled',
      enableAuthEmails: 'Sending emails for authorization is enabled',
      createTeam: 'Team successfully created',
      changeTeam: 'Team successfully changed',
      transferTeam: 'The employees successfully transferred',
      deleteTeam: 'The team was successfully deleted',
      deleteEmployee: 'The employee was successfully deleted',
      checkTeamTests360:
        'The team has 360 scores. To delete the team and move employees to a new team, contact support.',
    },
    errorMessages: {
      dismissEmployee: 'Failed to dismiss the employee',
      reinstateEmployee: 'Failed to reinstate the employee',
      importEmployees: 'Failed to import the employees',
      importEmployeesDialog: 'Some users have not been uploaded, please see the list of errors.',
      inviteEmployee: 'Failed to invite an employee',
      cancelInvitationEmployee: 'Failed to cancel the invitation',
      disableAuthEmails: 'Failed to disable sending emails for authorization',
      enableAuthEmails: 'Failed to enable sending emails for authorization',
      diagramInNotAvailable:
        'There is no data on interaction for the selected employees for the last 30 days. To get data for a different period, use Export to Excel.',
      getAvailabilityDiagram: "Couldn't check diagram availability",
      createTeam: 'Failed to create a team',
      changeTeam: 'Failed to change the team',
      transferTeam: 'Failed to transfer the employees',
      deleteTeam: 'Failed to delete the team',
      deleteEmployee: 'Failed to delete the employee',
      checkTeamTests360:
        'Failed to check for 360 scores in the team. To delete the team and move employees to a new team, contact support.',
      checkStatuses: 'Failed to check the upload status of users',
    },
    // confirm dialogs
    confirmDismissEmployee: {
      title: 'Dismiss the employee?',
      text: 'The employee will be excluded from all company teams',
      button: 'Yes, dismiss',
    },
    confirmInviteEmployee: {
      title: 'Send an invitation?',
      text: 'This user will be sent an invitation to join your company',
      button: 'Yes, send',
    },
    confirmReinstateEmployee: {
      title: 'Reinstate the employee?',
      text: 'The employee will be moved to the list of current employees of the company.',
      button: 'Yes, reinstate',
    },
    confirmCancelInviteEmployee: {
      title: 'Cancel an invitation?',
      text: 'If you cancel the invitation, it will disappear from the invited user',
      button: 'Yes, cancel',
    },
    confirmEnableAuthEmails: {
      title: 'Are you sure?',
      text: 'Sending emails with authorization data to users will be enabled',
      button: 'Yes, enable',
    },
    confirmDeleteTeam: {
      title: 'Delete the team?',
      text: 'The team has 360 scores. When you delete the team, the 360 scores will be permanently deleted. First, use the form to transfer the scores and then go back to deleting the team.',
      button: 'Yes, delete',
    },
    reConfirmDeleteTeam: {
      title: 'Delete the team with 360 scores?',
      text: 'Are you sure you want to delete the team with 360 scores? The scores cannot be restored, including through technical support.',
      button: 'Yes, delete',
    },
    confirmDeleteEmployee: {
      title: 'Delete the employee?',
      text: 'Are you sure you want to delete an employee? The employee will be deleted without possibility of recovery.',
      button: 'Yes, delete',
    },
    //
  },
};
